const NBSP = "\u00A0";

export const STEP_LABELS = {
    TABLET: NBSP.repeat(6),
    DESKTOP: NBSP.repeat(12),
} as const;

export const createStepsWithLabels = (isTablet: boolean, totalSteps: number) =>
    Array.from({ length: totalSteps }, (_, index) => ({
        orderId: index,
        label: isTablet ? STEP_LABELS.TABLET : STEP_LABELS.DESKTOP,
    }));
